<template>
    <div v-if="breakingScreenNews.length === 0" class="wrapper">
        <div class="logo" :style="{ 'background-image': 'url('+ this.asset('img/svg/FeuchterStiftungLogo.svg') + ')',}"></div>
        <div class="date">{{day}} <br> {{date}}</div>
        <clock class="clock"></clock>
    </div>
    <div v-else class="grid-wrapper">
        <div class="grid-logo" :style="{ 'background-image': 'url('+ this.asset('img/svg/FeuchterStiftungLogo.svg') + ')',}"></div>
        <div class="grid-date">{{day}} <br> {{date}}</div>
        <breaking-banner class="breaking-banner" :breaking="breakingScreenNews"></breaking-banner>
        <div class="grid-clock">
            <clock class="clock"></clock>
        </div>
        
    </div>
</template>

<style lang="scss" scoped>
.wrapper {
    background-color: $font-color;
    height: 100%;
    margin: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.grid-wrapper {
    background-color: $font-color;
    height: 100%;
    margin: 0;
    display: grid;
    grid-template-columns: 45vw auto 82vh;
    grid-template-rows: 55vh;
}
.logo {
    height: 54vh;
    width: 45vw;
    background-position: center;
    background-size: 70% 100%;
    background-repeat: no-repeat;
}
.grid-logo {
    padding: 20px;
    background-origin: content-box;
    width: 45vw;
    background-position: center;
    background-size: 70% 100%;
    background-repeat: no-repeat;
    align-items: center;
    grid-column: 1 ;
    grid-row: 1 ;
}
.clock {
    position: relative;
    width: 82vh;
    height: 82vh;
}
.grid-clock {
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    grid-column: 3 ;
    grid-row: 1 / 3;
}
.grid-date{
    color: #ffffff;
    display: flex;
    align-content: center;
    justify-content: center;
    font-size: 20vh;
    margin-right: auto;
    grid-column: 2;
    grid-row: 1;
}
.date{
    color: #ffffff;
    display: flex;
    align-items: center;
    height: 100vh;
    font-size: 20vh;
    margin-right: auto;
}
.breaking-banner {
    grid-column: 1 / 3;
    grid-row: 2;
}
</style>
<script>
    import moment from 'moment';
    export default {
        created() {
            this.fetchNews();
            setInterval(this.fetchNews, 60000); //alle 1min auf neue News prüfen
        },
        methods: {
            fetchNews() {
                this.$store.dispatch({
                    type: 'moduleNews/fetchNews',
                }).catch((error) => {
                    if(error.response.status === 401) {
                        this.$root.$emit('unauthenticated');
                    } else {
                        this.apiErrorMessageHandler(error);
                    }
                });
            }
        },
        computed: {
            breakingScreenNews() {
                return this.$store.getters['moduleNews/news'].filter((news) => {return news.breaking_alert && news.show_playout})
            },
            day() {
                return moment(moment.now()).locale('de').format('dddd');
            },
            date() {
                return moment(moment.now()).locale('de').format('DD.MM.YYYY');
            }
        }
    }
</script>